import { FormattedMessage } from "react-intl";
type Props = {
  consentToMarketing: boolean;
  handleChange: (id: string, value: boolean) => void;
};

const ConsentToMarketing = ({ consentToMarketing, handleChange }: Props) => {
  return (
    <div className="form-details__row--input form-details__row--input--checkbox">
      <span className="checkbox-input">
        <input
          type="checkbox"
          id="consentToMarketing"
          name="consentToMarketing"
          checked={consentToMarketing}
          onChange={() =>
            handleChange("consentToMarketing", !consentToMarketing)
          }
        />
      </span>
      <FormattedMessage tagName="" id="consent-to-marketing" />
    </div>
  );
};

export default ConsentToMarketing;
